import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getQuotations = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/quotations?include=quotationItems,opportunity&' + params.toString()); // Let the error bubble up
};

const getQuotationById = async (id: number) => {
  return await apiClient.get(`/quotations/${id}`); // Fetch car listing by ID
};

const createQuotation = async (quotationData: any) => {
  return await apiClient.post('/quotations', quotationData); // Create a new car listing
};

const updateQuotation = async (id: number, quotationData: any) => {
  return await apiClient.patch(`/quotations/${id}`, quotationData); // Update car listing by ID
};

const deleteQuotation = async (id: number) => {
  return await apiClient.delete(`/quotations/${id}`); // Delete car listing by ID
};

const getQuotedByUser = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/quoted-by-user?' + params.toString()); // Let the error bubble up
};

const getQuotationsTotals = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/dashboard/quotations-report?' + params.toString()); // Let the error bubble up
};

const exportPdf = async (id: number) => {
  return await apiClient.get(`/quotation/export-pdf/${id}`, {
    responseType: 'blob',
  });
};

const convertQuotation = async (id: number, client: any, additional_data:any) => {
  return await apiClient.post(`/quotation/convert/${id}`, { client: client, additional_data:additional_data } );
};

const authorizeQuotationItem = async (id: any) => {
  return await apiClient.post('/quotation/authorize', {quotation_item_ids:[id]});
};

const authorizeQuotation = async (quotationData: any) => {
  return await apiClient.post('/quotation/authorize', quotationData);
};

const exportCSV = async (params: string, body: any) => {
  return await apiClient.post(`/quotations/export?${params}`, body, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
};

export default {
  getQuotations,
  getQuotationById,
  createQuotation,
  updateQuotation,
  deleteQuotation,
  getQuotedByUser,
  getQuotationsTotals,
  exportPdf,
  convertQuotation,
  authorizeQuotationItem,
  authorizeQuotation,
  exportCSV
};
